import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { Link } from "react-router-dom";
import { styled } from "@mui/material";
import Stack from "@mui/material/Stack";
import LoaderCircular from "ui/atoms/LoaderCircular";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import Dialog from "ui/organisms/Dialog";
import GroupsTable from "./components/GroupsTable";
import FormCard from "components/Forms/FormCard/FormCard";
import NewToast from "ui/atoms/NewToast";
import { deleteGroup, getGroups, hideToast } from "app/features/groupsSlice";
import { getToastMessage } from "lib/helpers/toastMessageHelper";
import withAuth from "lib/hoc/withAuth";

const Groups = () => {
  const dispatch = useAppDispatch();
  const [isOpen, setIsOpen] = useState<Boolean>(false);
  const [selectedGroupId, setSelectedGroupId] = useState<number>(0);
  const { error, loading, groups, severity, response, showToast } = useAppSelector((state) => state.groups);

  const handleDialog = (groupId: number) => {
    setIsOpen(true);
    setSelectedGroupId(groupId);
  };

  const handleDelete = async () => {
    await dispatch(deleteGroup(selectedGroupId));
    setIsOpen(false);
  };

  useEffect(() => {
    dispatch(getGroups());
  }, []);

  const onCloseToast = () => {
    dispatch(hideToast());
  };
  return (
    <>
      <NewToast open={showToast} setOpen={onCloseToast} severity={severity}>
        {getToastMessage(response, error)}
      </NewToast>
      <Dialog
        open={isOpen}
        setOpen={setIsOpen}
        title='Eliminar Grupo'
        message='¿Está seguro que desea eliminar este grupo?'
        onHandleOk={handleDelete}
      />
      <FormCard maxWidthCard={1150} maxWidthContainer='lg' title='Grupos'>
        <Link to='/admin/group-create'>
          <ButtonWrapper direction='row' spacing={2}>
            <Button variant='outlined' startIcon={<AddIcon />}>
              Nuevo Grupo
            </Button>
          </ButtonWrapper>
        </Link>

        {groups?.length > 0 && !loading ? (
          <GroupsTable groups={groups} handleDialog={handleDialog} />
        ) : (
          <LoaderCircular />
        )}
      </FormCard>
    </>
  );
};
const ButtonWrapper = styled(Stack)`
  margin: ${({ theme }) => theme.spacing(2, 3)};
`;

export default withAuth(Groups);
